import React from 'react';

import Grid from '../Grid'
import StatusMessage from '../StatusMessage'
import useForm from '../hooks/useForm'
import { ConfigContext } from '../Config/ConfigContext'

import {
    useNavigate
} from 'react-router-dom';
import {
    Box
} from '@mui/system';

import {
    Button, TableCell,
} from '@mui/material';

export default function Email() {
    const navigate = useNavigate();
    const { config } = React.useContext(ConfigContext)

    const {
        state,
    } = useForm({
        initialState: {
            modalToggle: false,
            config,
            statusType: '',
            statusMessage: '',
        },
    });


    return (
        <div>
            {state.values.statusType &&
                <StatusMessage
                    messageType={state.values.statusType}
                    message={state.values.statusMessage}
                />
            }

            <Box
                sx={{ display: 'flex', justifyContent: 'flex-end' }}
            >
                <Button
                    variant={'contained'}
                    onClick={() => navigate('/admin/email/templates')}
                >Manage Email Templates</Button>
            </Box>
            <Grid
                tableName={'Email Logs'}
                searchEndpont={`${config.uri.base}/email/log`}
                headCells={[
                    {
                        id: 'appId',
                        numeric: false,
                        disablePadding: true,
                        label: 'App Id',
                    },
                    {
                        id: 'templateName',
                        numeric: false,
                        disablePadding: true,
                        label: 'Template'
                    },
                    {
                        id: 'envelope.from',
                        numeric: false,
                        disablePadding: true,
                        label: 'From',
                        render: ({ rowData }) => {
                            const fromAddress = rowData.envelope.from;
                            return (
                                <TableCell
                                    component="th"
                                    scope="row"
                                    padding="none">
                                    <span>{fromAddress}</span>
                                </TableCell>

                            );
                        }
                    },
                    {
                        id: 'envelope.to',
                        numeric: false,
                        disablePadding: true,
                        label: 'To',
                        render: ({ rowData }) => {
                            const toAddresses = rowData.envelope.to.join(',');
                            return (
                                <TableCell
                                    component="th"
                                    scope="row"
                                    padding="none">
                                    <span>{toAddresses}</span>
                                </TableCell>
                            );
                        }
                    },
                    {
                        id: 'insertedDTM',
                        numeric: false,
                        disablePadding: true,
                        label: 'Created At',
                    },

                ]}
                filterList={[
                    {
                        id: 'name',
                        dataType: 'string',
                        label: 'Application Name',
                        defaultValue: ''
                    },

                ]}
            />
        </div>
    );
}

